import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { CAR_TYPE_PREFIX_URL } from './constants/config.car-type'

const ListPage = lazy(() => import('./pages/ListPage.CarType'))

const CarTypeRouters: AppRouterItem[] = [
  {
    path: `${CAR_TYPE_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default CarTypeRouters
